import React from 'react';

import { useStudentDispatch } from '../../../hooks/useStudentDispatch';
import {
  AudioCurrentTimeUpdated,
  AudioInitialized,
  AudioPlayStatusChanged,
} from '../../../store/reducers/student/audio/audioReducer';
import { Audio } from '../Audio';
import { useAudioCaptionsActionsContext } from '../AudioCaptionsContextProvider';
import { useAreAudioCaptionsEnabled, useToggleAudioCaptions } from '../editorHooks/captionPreferencesHooks';
import { AudioAssetPlayerProps } from './AudioAssetPlayer';
import { PlayStatus } from '@ael/shared-components-library';

export const StudentAudioAssetPlayer = (props: AudioAssetPlayerProps) => {
  const areAudioCaptionsEnabled = useAreAudioCaptionsEnabled();
  const toggleAudioCaptions = useToggleAudioCaptions(areAudioCaptionsEnabled);
  const { setCaptions } = useAudioCaptionsActionsContext();
  const dispatch = useStudentDispatch();

  if (!props.audioAsset) {
    return null;
  }

  return (
    <Audio
      key={props.uniqueAudioKey}
      src={props.audioAsset.track.assetUrl}
      captionSrc={props.audioAsset.subtitles?.assetUrl}
      onCaptionTextChange={setCaptions}
      captionsEnabled={areAudioCaptionsEnabled}
      onCaptionsClick={toggleAudioCaptions}
      isCollapsible={props.isMobileDevice}
      // Handle events
      onPlaying={() => dispatch(AudioPlayStatusChanged(props.uniqueAudioKey, PlayStatus.Playing))}
      onEnded={() => dispatch(AudioPlayStatusChanged(props.uniqueAudioKey, PlayStatus.Finished))}
      onPause={() => dispatch(AudioPlayStatusChanged(props.uniqueAudioKey, PlayStatus.NotStartedOrPaused))}
      onLoadedMetadata={(duration) => dispatch(AudioInitialized(props.uniqueAudioKey, duration))}
      onTimeUpdate={(currentTime) => dispatch(AudioCurrentTimeUpdated(props.uniqueAudioKey, currentTime))}
    />
  );
};
